/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, Modal } from 'react-bootstrap';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';

import { DocumentHistroy } from '../components/DocumentHistroy';
import { Notes } from '../components/Notes';
import { OwnerAutocomplete } from '../components/OwnerAutocomplete';
import { AddEditTag } from '../../../components/commonAction/AddEditTag';
import {
    userPermission,
    stringEmptyOrUndefined,
    GetFieldData,
    getNotes,
    formatNameWithSpaceToUnderscore,
    formatPathName,
} from '../../../components/commonfunction';
import RelatedDocument from '../components/RelatedDocument';
import {
    showLoader,
    getListaction,
    inboxPage,
} from '../../_redux/actions/inboxActions';
import UpdateFaxDetails from '../components/UpdateFaxDetails';
import Office365AuthenticationPage from '../../../components/composeDraftMail/Office365AuthenticationPage';
import GmailAuthenticationPage from '../../../components/composeDraftMail/GmailAuthenticationPage';
import SendToFaxUploadModal from '../components/SendToFaxUploadModal';
import LockBar from '../../../components/LockBar';
import NotesSection from './components/NotesSection';
import DetailsSection from './components/DetailSection';
import TransitionButton from './components/TransitionButton';
import EditDetailsButton from './components/EditDetailsButton';
import NotesButton from './components/NotesButton';
import PDFEditButton from './components/PDFEditButton';
import SettingsDropdown from './components/SettingsDropdown';
import TransitionSection from './components/TransitionSection';
import { getDocumentMetaWithDocId, getConfigurationData } from '../../api/api';
const DocumentDetail = (props) => {
    const handleOwnerRef = useRef();

    const [state, setState] = useState({
        open_transition_section: false,
        open_details_section: false,
        edit_transition: false,
        is_add_notes: '',
        openHistroy: false,
        toggleRecentDoc: false,
        detailBigView: props.detailView ?? false,
        selectedDoc: [],
        openNote: false,
        docSpinner: false,
        rowDetails: undefined,
        ownerlist: [],
        showOwnerDropDown: false,
        tagData: [],
        tagCount: 0,
        openTag: false,
        docId: undefined,
        more_information: false,
        printSelectedDocId: [],
        viewAllNotes: false,
        noteCount: 0,
        viewNotes: false,
        show_owner: false,
        show_tag: false,
        show_branch: false,
        show_group: false,
        show_inbox: false,
        show_notes: true,
        show_pdf: true,
        show_delete: false,
        processId: null,
        statusId: null,
        statusArray: [],
        branchActionId: null,
        groupActionId: null,
        editId: '',
        detailPage: props.detailView ?? false,
        viewAllOpen: false,
        menuBranch: '',
        menuGroup: '',
        menuInbox: '',
        resetCount: false,
        allActions: { details: '' },
        noteTypes: [],
        serviceType: false,
        relatedDocRefresh: true,
        expandWasPressed: false,
    });

    const onInitialActions = () => {
        let tagData = [];
        let tagCount = 0;
        let doc_id = 0;
        let rowDetails = {};
        let processId;
        let statusId;
        if (
            props.inbox.selectedRowDetails !== undefined &&
            props.inbox.selectedRowDetails.statuses !== undefined &&
            props.inbox.selectedRowDetails.statuses[0] !== undefined &&
            props.inbox.selectedRowDetails.statuses[0].processId !== undefined
        ) {
            processId = props.inbox.selectedRowDetails.statuses[0].processId;
            statusId = props.inbox.selectedRowDetails.statuses[0].statusId;
        } else {
            processId = props.processId;
            statusId = props.statusId;
        }

        if (
            props.inbox.stateData !== undefined &&
            props.inbox.stateData.rowDetails !== undefined &&
            props.rowDetails !== undefined
        ) {
            rowDetails = props.inbox.stateData.rowDetails;
            let tags_data = '';
            doc_id = props.inbox.selectedRowDetails.miscPproperties.docId;
            props.inbox.stateData.rowData.forEach((data, index) => {
                if (data.doc_id === doc_id) {
                    tags_data = data.tags_data;
                }
            });

            if (
                tags_data !== undefined &&
                tags_data !== '' &&
                tags_data !== '|'
            ) {
                const lastChar = tags_data.substr(tags_data.length - 1); // => "1"
                if (String(lastChar) === '|') {
                    tags_data = tags_data.slice(0, -1); // 'abcde'
                }

                tagData = tags_data.split('|');
                tagCount = tagData.length;
            }
        }
        let ownerlist = [];
        if (props.ownerlist !== undefined) {
            ownerlist = props.ownerlist;
        }
        let permission = userPermission({
            processId: processId,
            statusId: statusId,
            menu_name: props.currentMenuName,
            configData: props.configData,
        });

        setState((prevState) => ({
            ...prevState,
            user_permission: permission,
            show_branch: permission.show_branch,
        }));

        permission = { ...permission, show_pdf: true, show_notes: true };
        const fieldDataObj = GetFieldData({
            configData: props.configData,
        });
        setState((prevState) => ({
            ...prevState,
            ownerFieldId: fieldDataObj.ownerFieldId,
        }));

        if (state.resetCount === false) {
            setState((prevState) => ({ ...prevState, tagCount: tagCount }));
        }

        setState((prevState) => ({
            ...prevState,
            rowDetails,
            ownerlist,
            tagData,
            docId: doc_id,
            processId,
            statusId,
            ...permission,
        }));
    };

    const formatName = (name) => {
        let name_array;
        let displayName;
        if (name !== '' && name !== undefined && name !== null) {
            name_array = name.split(' ');
            if (name_array.length > 1) {
                displayName = `${name_array[0]
                    .charAt(0)
                    .toUpperCase()}${name_array[1].charAt(0).toUpperCase()}`;
            } else {
                const username = name.substring(0, 3);

                if (username === 'WV-') {
                    displayName = `${name[3].toUpperCase()}${name[4].toUpperCase()}`;
                } else {
                    displayName = `${name_array[0]
                        .charAt(0)
                        .toUpperCase()}${name_array[0]
                        .charAt(1)
                        .toUpperCase()}`;
                }
            }
        }

        return displayName;
    };

    const handleOwnerName = () => {
        let name = '';
        let bg_color = '#8B36BF';
        let titleName = '';

        props.inbox.stateData?.rowData?.forEach((data, index) => {
            if (
                data.doc_id ===
                props.inbox.selectedRowDetails.miscPproperties.docId
            ) {
                name = data.owner_rawdata;
            }
        });
        let ownerColor = [];
        ownerColor = JSON.parse(localStorage.getItem('owner_bg_color'));

        if (name === undefined || String(name).trim() === '') {
            let ownerId = '';
            const fieldDataObj = GetFieldData({
                configData: props.configData,
            });
            if (props.inbox.selectedRowDetails.hasOwnProperty('fields')) {
                props.inbox.selectedRowDetails.fields.map((data) => {
                    if (data.fieldId === fieldDataObj.owner) {
                        ownerId = data.value;
                    }
                });
            }
            if (ownerColor !== null && Array.isArray(ownerColor)) {
                ownerColor.forEach((owner) => {
                    if (owner.ownerId === ownerId) {
                        name = owner.name;
                        titleName = owner.name;
                    }
                });
            }
        }

        if (ownerColor !== null && Array.isArray(ownerColor)) {
            ownerColor.forEach((owner) => {
                if (owner.name === name) {
                    bg_color = owner.colorCode;
                }
            });
        }

        if (state.show_owner === false) {
            return <></>;
        }

        if (state.show_owner === false) {
            return (
                <>
                    <button
                        type='button'
                        id='owner-display-name'
                        className='no-user-icon owner-logo'
                        ref={handleOwnerRef}
                        style={{ cursor: 'not-allowed' }}
                        disabled={props.isLocked === true}
                    >
                        <i
                            className={
                                state.allActions.hasOwnProperty(
                                    'assign_to_user'
                                ) &&
                                state.allActions.assign_to_user.icon !== null
                                    ? state.allActions.assign_to_user.icon
                                    : 'fas fa-user-plus'
                            }
                            style={{
                                color:
                                    state.allActions.hasOwnProperty(
                                        'assign_to_user'
                                    ) &&
                                    state.allActions.assign_to_user.color !==
                                        null
                                        ? state.allActions.assign_to_user.color
                                        : '',
                            }}
                        />
                    </button>
                </>
            );
        }
        if (name === undefined || String(name).trim() === '') {
            return (
                <>
                    <button
                        type='button'
                        id='owner-display-name'
                        className='no-user-icon owner-logo'
                        ref={handleOwnerRef}
                        title={titleName}
                        disabled={
                            props.callingFrom === 'related_document' ||
                            props.isLocked
                        }
                        style={
                            props.callingFrom === 'related_document' ||
                            props.isLocked
                                ? { cursor: 'not-allowed' }
                                : {}
                        }
                        onClick={handleOwnerFocus}
                    >
                        <i
                            className={
                                state.allActions.hasOwnProperty(
                                    'assign_to_user'
                                ) &&
                                state.allActions.assign_to_user.icon !== null
                                    ? state.allActions.assign_to_user.icon
                                    : 'fas fa-user-plus'
                            }
                            style={{
                                color:
                                    state.allActions.hasOwnProperty(
                                        'assign_to_user'
                                    ) &&
                                    state.allActions.assign_to_user.color !==
                                        null
                                        ? state.allActions.assign_to_user.color
                                        : '',
                            }}
                        />
                    </button>
                </>
            );
        }
        name = formatName(name);
        return (
            <>
                <button
                    type='button'
                    id='owner-display-name'
                    style={{
                        cursor:
                            props.callingFrom === 'related_document' ||
                            props.isLocked
                                ? 'not-allowed'
                                : 'allowed',
                        backgroundColor: bg_color,
                    }}
                    className='username'
                    ref={handleOwnerRef}
                    title={titleName}
                    onClick={
                        props.callingFrom !== 'related_document'
                            ? handleOwnerFocus
                            : {}
                    }
                    disabled={props.isLocked}
                >
                    {name}
                </button>
            </>
        );
    };

    const handleOwnerNameReset = (name) => {
        props.inbox.stateData.rowData.forEach((data, index) => {
            if (data.doc_id === state.rowDetails.doc_id) {
                data.owner_rawdata = name;
            }
        });
    };

    const handleOwnerFocus = () => {
        setState((prevState) => ({
            ...prevState,
            showOwnerDropDown: !prevState.showOwnerDropDown,
            openTag: false,
        }));

        if (isMobile && document.querySelector('.owner-autocomplete')) {
            const el = document.querySelector('.owner-autocomplete');
            el.style.left = '71.48438px';
            el.style.top = '50px';
        }
    };

    const handleOwnerHide = () => {
        setState((prevState) => ({ ...prevState, showOwnerDropDown: false }));
    };

    const handleTagOpen = () => {
        setState((prevState) => ({
            ...prevState,
            openTag: !state.openTag,
            showOwnerDropDown: false,
        }));
    };

    const handleTagClose = () => {
        setState((prevState) => ({
            ...prevState,
            openTag: false,
        }));
    };

    const set_opendeletepopup = (event) => {
        props.openDeletePopUp(event);
    };

    const open_transition_section = () => {
        setState((prevState) => ({
            ...prevState,
            open_transition_section: !state.open_transition_section,
            open_details_section: false,
            open_notes_section: false,
        }));
    };

    const open_notes_section = () => {
        setState((prevState) => ({
            ...prevState,
            open_transition_section: false,
            open_details_section: false,
            open_notes_section: !state.open_notes_section,
            is_add_notes: 1,
        }));
    };

    const doCollapse = async () => {
        await document.body.classList.remove('aside-minimize');
        await document.body.classList.remove('doc-small-view');

        setState((prevState) => ({
            ...prevState,
            row_transition: false,
        }));

        props.rowTransition();
        if (isMobile) {
            document.body.classList.remove('small-view-display');
        }
        setTimeout(() => {
            const checkBox =
                document.getElementsByClassName('rdg-checkbox-input');
            if (checkBox !== null) {
                for (let i = 0; i < checkBox.length; i++) {
                    checkBox[i].disabled = false;
                    checkBox[i].removeAttribute('disabled');
                }
            }
        }, 20);
        props.inboxPage({
            docOpen: false,
            collapseSmallView: true,
        });

        // 10098: Turn edit details off when closing document detail view
        props.closeEditDetails();
        props.resetSelectedDocId();
    };

    const doExpand = () => {
        document.body.classList.remove('doc-small-view');
        document.body.classList.add('doc-detail-view');
        if (document.getElementById('left-aside') !== null) {
            document
                .getElementById('left-aside')
                .classList.add('aside-small-view');
        }
        const checkBox = document.getElementsByClassName('rdg-checkbox-input');
        if (checkBox !== null) {
            for (let i = 0; i < checkBox.length; i++) {
                checkBox[i].disabled = true;
            }
        }
        props.openBigView();

        setState((prevState) => ({
            ...prevState,
            detailBigView: true,
            listingView: false,
        }));

        if (isMobile) {
            document.body.classList.remove('small-view-display');
        }

        setState((prevState) => ({
            ...prevState,
            printSelectedDocId: [],
        }));
    };

    const expandNextLockedDocumentInCorrectManner = () => {
        doExpand();
        props.openEditDetails();
        props.mimickCancelClick();
        setTimeout(() => {
            collapseBigView();
        }, 75);
    };

    const expandAndOpenDetails = () => {
        doExpand();
        props.openEditDetails();
        props.mimickCancelClick();

        setState((prevState) => ({
            ...prevState,
            expandWasPressed: true,
        }));
    };

    const openEditDetailsFromDocumentDetail = () => {
        doExpand();
        props.openEditDetails();

        setState((prevState) => ({
            ...prevState,
            expandWasPressed: true,
        }));
    };

    const initialize = async () => {
        if (props.isEditDetails && props.isPartialEditModeEnabled) {
            collapseBigView();
            props.turnPartialEditModeOn();
        }

        if (!props.isEditDetails && props.pdf_preview) {
            setTimeout(() => {
                if (
                    props.isLocked &&
                    (props.nextDocument || props.nextDocFromAttach)
                ) {
                    if (!props.isPartialEditModeEnabled) {
                        expandAndOpenDetails();
                    } else {
                        expandNextLockedDocumentInCorrectManner();
                    }
                }
            }, 75);
        }

        if (props.isTriggerCollapseFromDetailBigView) {
            collapseBigView();
            props.terminateCollapseFromDetailBigViewRequest();
        }

        const serviceType = ['Office 365', 'Google'].includes(
            props.configData?.emailIntegration?.serviceType
        );
        setState((prevState) => ({ ...prevState, serviceType }));

        onInitialActions();
        const pushEditId = [window.btoa(String(props.selectedDocId))];
        setState((prevState) => ({
            ...prevState,
            pushEditId,
            editId: props.pageCount > 0 ? `/documents/edit/${pushEditId}` : '',
        }));

        setTimeout(() => {
            if (props.isEditDetails && props.isPartialEditModeEnabled) {
                collapseBigView();
                props.turnPartialEditModeOn();
            }
        }, 100);

        if (props.nextDocument) {
            props.resetNextDoc();
            doExpand();
        }

        const noteTypes = getNotes(
            props.configData,
            props.processId,
            props.statusId
        );
        setState((prevState) => ({ ...prevState, noteTypes }));
    };

    useEffect(() => {
        initialize();

        return () => {
            props.closeEditDetails();
            // props.turnPartialEditModeOff();
        };
    }, [props.isLocked]);
    useEffect(() => {
        setTimeout(() => {
            if (props.isEditDetails && props.isPartialEditModeEnabled) {
                collapseBigView();
                props.turnPartialEditModeOn();
            }
        }, 100);
    }, [props.isEditDetails, props.isPartialEditModeEnabled]);

    useEffect(() => {
        if (props.expandWasPressedEvent) {
            setState((prevState) => ({ ...prevState, expandWasPressed: true }));
            props.cancelExpandWasPressedEvent();
        }

        if (props.stateToken) {
            setTimeout(onInitialActions, 500);
        }
    }, [props.expandWasPressedEvent, props.stateToken]);

    useEffect(() => {
        if (state.noteCount !== props.noteCount) {
            if (props.noteCount !== 0) {
                setState((prevState) => ({ ...prevState, viewNotes: false }));
                setTimeout(() => {
                    setState((prevState) => ({
                        ...prevState,
                        viewNotes: true,
                    }));
                }, 100);
            } else {
                setState((prevState) => ({ ...prevState, viewNotes: false }));
            }
        }
    }, [props.noteCount]);

    useEffect(() => {
        if (props.selectedDocId) {
            setState((prevState) => ({
                ...prevState,
                relatedDocRefresh: false,
                refreshRelatedDoc: false,
                printSelectedDocId: [],
                toggleRecentDoc: false,
                selectedDoc: [],
                selectedDocId: props.selectedDocId,
                noteCount: props.noteCount,
                open_transition_section: false,
                open_details_section: false,
                open_notes_section: false,
            }));

            setTimeout(onInitialActions, 500);

            setState((prevState) => ({
                ...prevState,
                refreshRelatedDoc: true,
                relatedDocRefresh: true,
            }));
        }
    }, [props.selectedDocId]);

    useEffect(() => {
        const fetchPhysicianSignatureDetails = async () => {
            // 10067: Fetch Physician Signature Details
            if (props.isPhyisicanSignatureDocument) {
                try {
                    let docid =
                        props.onRowClickId ||
                        props.selectedRowDetails.miscPproperties.docId;
                    const { fields } = await getDocumentMetaWithDocId({
                        docid,
                    });
                    const configData = getConfigurationData();
                    const mappedFields = {};

                    fields.forEach((field) => {
                        const { fieldId, value } = field;
                        for (const key in configData) {
                            if (configData.hasOwnProperty(key)) {
                                const configItem = configData[key];
                                if (configItem.fieldId === fieldId) {
                                    mappedFields[configItem.name] = value;
                                    break;
                                }
                            }
                        }
                    });

                    // Set the values from mappedFields
                    props.setPhysicianSignatureCity(mappedFields['City']);
                    props.setPhysicianSignatureFileName(
                        mappedFields['File Name']
                    );
                    props.setPhysicianSignatureNPI(mappedFields['NPI']);
                    props.setPhysicianSignatureOrderingPhysician(
                        mappedFields['Ordering Physician']
                    );
                    props.setPhysicianSignatureState(mappedFields['State']);
                    props.setPhysicianSignatureSignedDate(
                        props.rowDetails.documentdate
                    );
                } catch (error) {
                    console.error('Error fetching or processing data:', error);
                }
            }
        };

        fetchPhysicianSignatureDetails();
    }, [props.isPhyisicanSignatureDocument]); // Dependency array, ensuring it runs only when the props change

    useEffect(() => {
        if (
            props.isExpandEditDetailsWhenNewPhysicianSignatureDocumentIsLoaded
        ) {
            openEditDetailsFromDocumentDetail();
            props.cancelExpandEditDetailsWhenNewPhysicianSignatureDocumentIsLoaded();
        }
    }, [props.isExpandEditDetailsWhenNewPhysicianSignatureDocumentIsLoaded]);

    useEffect(() => {
        const url = window.location.pathname.split('/');
        if (url[1] === 'detail' && !state.detailBigView) {
            setState((prevState) => ({ ...prevState, detailBigView: true }));
        }
    }, [window.location.pathname]);

    const entering = (e) => {
        e.children[0].style.borderTopColor = 'rgb(0, 35, 58)';
        e.children[1].style.backgroundColor = 'rgb(0, 35, 58)';
    };

    const download = async () => {
        await props.download();
    };

    const collapseBigView = () => {
        document.body.classList.remove('doc-detail-view');
        document.body.classList.add('doc-small-view');
        if (document.getElementById('left-aside') !== null) {
            document
                .getElementById('left-aside')
                .classList.remove('aside-small-view');
        }

        setState((prevState) => ({
            ...prevState,
            detailBigView: false,
        }));

        props.closeBigView();
        if (isMobile) {
            document.body.classList.add('small-view-display');
        }

        props.turnPartialEditModeOn();
        props.turnEditModeButtonActive();
        props.inboxPage({
            fromCollapse: true,
            docOpen: true,
        });

        setState((prevState) => ({
            ...prevState,
            expandWasPressed: false,
        }));
    };

    const openMore = () => {
        setState((prevState) => ({
            ...prevState,
            more_information: !state.more_information,
        }));
    };

    const closeTransition = () => {
        if (!['deleted_document', 'search'].includes(props.calingFrom)) {
            const storedQueryData = props.inbox?.stateData?.queryData || {};
            const queryData = {
                ...storedQueryData,
            };

            const processId = props.processId;
            const statusId = props.statusId;

            const filtersJson = localStorage.getItem(
                `customFilters_${processId}_${statusId}`
            );
            if (filtersJson) {
                queryData.filters = filtersJson;
            }

            const sortingJson = localStorage.getItem(
                `sorting_${processId}_${statusId}`
            );
            if (sortingJson) {
                try {
                    const sorting = JSON.parse(sortingJson);
                    queryData.sortColumn = sorting.sortColumn;
                    queryData.sortOrder = sorting.sortDirection;
                } catch (e) {
                    // ignore parse errors
                }
            }

            const perPage = localStorage.getItem(
                `perPage_${processId}_${statusId}`
            );
            if (perPage) {
                queryData.pageSize = parseInt(perPage, 10);
            }
            if (localStorage.getItem('retainShowAllChecked') === 'true') {
                queryData.pageSize = 50000;
            }

            const fullTextSearch = localStorage.getItem(
                `searchFilter_${processId}_${statusId}`
            );
            if (fullTextSearch) {
                queryData.fullTextSearchString = fullTextSearch;
            }

            if (!queryData.pageNumber) {
                queryData.pageNumber = 1;
            }

            props.getListaction(
                props.processId,
                props.statusId,
                props.calingFrom,
                queryData
            );
        }
        doCollapse();
    };

    const Update_fax_details = () => {
        const selectedRowDetails = props.inbox.selectedRowDetails.fields;
        const Fields = props.configData.fields;
        const allFields = [];

        Fields.map((data) => {
            allFields.push({
                fieldId: data.fieldId,
                name: formatNameWithSpaceToUnderscore(data.name),
            });
        });

        let fieldId;
        allFields.map((dataValue) => {
            if (dataValue.name === 'fax_detail') {
                fieldId = dataValue.fieldId;
            }
        });
        selectedRowDetails.map((data) => {
            if (data.fieldId === fieldId) {
                setState((prevState) => ({
                    ...prevState,
                    updateValue: data.value,
                }));
            }
        });

        setState((prevState) => ({
            ...prevState,
            openUpdateNotes: true,
            selectedDocId: props.selectedDocId,
        }));
    };

    const showFaxModal = () => {
        const selectedRowDetails = props.inbox.selectedRowDetails.fields;
        const Fields = props.configData.fields;
        const allFields = [];
        let fieldId;
        Fields.map((data) => {
            allFields.push({
                fieldId: data.fieldId,
                name: formatNameWithSpaceToUnderscore(data.name),
            });
        });
        selectedRowDetails.map((data) => {
            if (data.fieldId === fieldId) {
                setState((prevState) => ({
                    ...prevState,
                    updateValue: data.value,
                }));
            }
        });

        setState((prevState) => ({
            ...prevState,
            showfaxNow: true,
            selectedDocId: props.selectedDocId,
        }));
    };

    const handleUnlock = () => {
        props.onUnlock();
    };

    const sendDraft = async () => {
        const serviceType = props.configData?.emailIntegration?.serviceType;
        if (serviceType === 'Office 365') {
            // check to authenticate draft mail
            Office365AuthenticationPage({
                selectedDocID: props.selectedDocId,
                configData: props.configData,
            });
        } else {
            GmailAuthenticationPage({
                selectedDocID: props.selectedDocId,
                configData: props.configData,
            });
        }
    };

    const printIt = (data) => {
        props.pdfPrintRef.current.printPdf();
    };

    const backBtn = () => {
        if (state.detailPage === true) {
            return (
                <>
                    {' '}
                    <div className='back_btn' style={{ marginLeft: '5px' }}>
                        <button type='button' onClick={() => props.goToPage()}>
                            Back
                        </button>
                    </div>{' '}
                </>
            );
        }
        return null;
    };

    if (isMobile) {
        setTimeout(() => {
            if (
                document.getElementById('left-aside') !== null &&
                props.isLocked === false
            ) {
                document
                    .getElementById('left-aside')
                    .classList.add('no-lock-section');
            } else if (
                document.getElementById('left-aside') !== null &&
                props.isLocked
            ) {
                document
                    .getElementById('left-aside')
                    .classList.remove('no-lock-section');
            }
        });
    }

    const handleHistroy = () => {
        setState((prevState) => ({
            ...prevState,
            openHistroy: true,
        }));
    };

    const handleHistroyClose = () => {
        setState((prevState) => ({
            ...prevState,
            openHistroy: false,
        }));
    };

    const handleReset = () => {
        setState((prevState) => ({
            ...prevState,
            openNote: false,
        }));
    };

    const toggleSpinner = () => {
        setState((prevState) => ({
            ...prevState,
            docSpinner: !state.docSpinner,
        }));

        props.enableLoader(!state.docSpinner);
    };

    let position = { left: 0, top: 0 };

    const path_name = window.location.pathname;
    const pathname = formatPathName(path_name);

    if (handleOwnerRef.current && state.detailPage === false) {
        const pos = handleOwnerRef.current.getBoundingClientRect();
        position = { left: pos.left - 150, top: pos.top - 50 };
    }
    if (handleOwnerRef.current && state.detailPage === true) {
        const pos = handleOwnerRef.current.getBoundingClientRect();
        position = { left: pos.left, top: pos.top - 60 };
    }

    if (
        handleOwnerRef.current &&
        (pathname === 'search-patients' || pathname === 'search-physicians')
    ) {
        const pos = handleOwnerRef.current.getBoundingClientRect();
        position = { left: pos.left - 150, top: pos.top - 180 };
    }

    const resetCount = (count) => {
        setState((prevState) => ({
            ...prevState,
            tagCount: count,
            resetCount: true,
        }));
    };

    return (
        <>
            <div
                className={`toast-container ${state.toast_type}`}
                style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '25%',
                }}
            />

            {!props.isPartialEditModeEnabled && props.isLocked && (
                <>
                    <LockBar
                        docId={props.selectedDocId}
                        isCalledFromGrid={false}
                        onUnlock={handleUnlock}
                    />
                    <div style={{ marginBottom: '25px' }}></div>
                </>
            )}
            {state.expandWasPressed || props.isEditDetails ? (
                <div
                    className={
                        props.isLocked
                            ? 'd-flex align-items-center mt-5 mb-5'
                            : 'd-flex align-items-center mb-5'
                    }
                >
                    {isMobile ? backBtn() : null}

                    {!props.isPartialEditModeEnabled && props.isEditDetails && (
                        <div
                            className='left-pdf-button collapse-button mr-2'
                            onClick={collapseBigView}
                            style={{ display: 'inline-block' }}
                        >
                            <button type='button' title='Collapse'>
                                <i className='fas fa-arrow-to-right' />
                                Collapse
                            </button>
                        </div>
                    )}

                    {state.rowDetails !== undefined &&
                    state?.user_permission?.allActions?.hasOwnProperty(
                        'assign_to_user'
                    )
                        ? handleOwnerName()
                        : null}
                    {state.showOwnerDropDown &&
                    state?.user_permission?.allActions?.hasOwnProperty(
                        'assign_to_user'
                    ) ? (
                        <div
                            style={{
                                ...{
                                    padding: '9px',
                                    borderRadius: '10px',
                                    border: '1px solid #00233A',
                                    width: '230px',
                                    background: '#fff',
                                    position: 'absolute',
                                    zIndex: 1,
                                },
                                ...position,
                            }}
                            className='owner-autocomplete'
                        >
                            <OwnerAutocomplete
                                ownerlist={state.ownerlist}
                                ownerName={props.inbox.stateData?.rowData?.filter(
                                    (item) =>
                                        item.doc_id === props.rowDetails.doc_id
                                )}
                                ownerValue={state.rowDetails.owner_rawdata}
                                handleHide={handleOwnerHide}
                                docId={props.selectedDocId}
                                handleOwnerNameReset={handleOwnerNameReset}
                                actionId={state.ownerActionId}
                                ownerFieldId={state.ownerFieldId}
                            />
                        </div>
                    ) : null}
                    {props.isLocked ? (
                        props.detailView === undefined &&
                        state.user_permission?.processName !== 'Export' &&
                        state?.user_permission?.allActions?.hasOwnProperty(
                            'update_tag'
                        ) ? (
                            <span
                                style={{ cursor: 'not-allowed' }}
                                className={
                                    state.tagCount > 0
                                        ? 'details-tag contain-tag-value ml-3'
                                        : 'details-tag ml-3'
                                }
                                id='details-tag'
                                disabled
                            >
                                <span className='fatag active '>
                                    <i
                                        className={
                                            state.allActions.hasOwnProperty(
                                                'update_tag'
                                            ) &&
                                            state.allActions.update_tag.icon !==
                                                null
                                                ? state.allActions.update_tag
                                                      .icon
                                                : 'fas fa-tag'
                                        }
                                        style={{
                                            color:
                                                state.allActions.hasOwnProperty(
                                                    'update_tag'
                                                ) &&
                                                state.allActions.update_tag
                                                    .color !== null
                                                    ? state.allActions
                                                          .update_tag.color
                                                    : '',
                                        }}
                                    />
                                </span>
                                <span className='count'>
                                    {state.tagData.length}{' '}
                                </span>
                            </span>
                        ) : null
                    ) : state.show_tag === true &&
                      state?.user_permission?.allActions?.hasOwnProperty(
                          'update_tag'
                      ) ? (
                        <Dropdown className='tag_dropdown '>
                            <Dropdown.Toggle className='dropdown_btn'>
                                {props.detailView === undefined ? (
                                    <span
                                        className={
                                            state.tagCount > 0
                                                ? 'details-tag contain-tag-value'
                                                : 'details-tag'
                                        }
                                        title={state.tagData
                                            .filter((e) => e)
                                            .join(', ')}
                                        id='details-tag'
                                        onClick={() => {
                                            handleTagOpen();
                                        }}
                                    >
                                        <span
                                            className={
                                                state.tagData.filter((e) => e)
                                                    .length > 0
                                                    ? 'fatag active'
                                                    : 'fatag'
                                            }
                                        >
                                            <i
                                                className={
                                                    state.allActions.hasOwnProperty(
                                                        'update_tag'
                                                    ) &&
                                                    state.allActions.update_tag
                                                        .icon !== null
                                                        ? state.allActions
                                                              .update_tag.icon
                                                        : 'fas fa-tag'
                                                }
                                                style={{
                                                    color:
                                                        state.allActions.hasOwnProperty(
                                                            'update_tag'
                                                        ) &&
                                                        state.allActions
                                                            .update_tag
                                                            .color !== null
                                                            ? state.allActions
                                                                  .update_tag
                                                                  .color
                                                            : '',
                                                }}
                                            />
                                        </span>
                                        <span className='count here'>
                                            {state.tagData.filter((e) => e)
                                                .length > 0
                                                ? state.tagData.filter((e) => e)
                                                      .length
                                                : null}
                                        </span>
                                    </span>
                                ) : null}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <div>
                                    <AddEditTag
                                        page='inbox'
                                        selectedTag={props.menuSelectedTags}
                                        tagList={props.menuTags}
                                        tagColorArray={props.tagColorArray}
                                        selectedTagNameData={state.tagData}
                                        docId={props.selectedDocId}
                                        rowDetails={
                                            props.inbox.stateData.rowDetails !==
                                            undefined
                                                ? props.inbox.stateData
                                                      .rowDetails
                                                : ''
                                        }
                                        resetCount={resetCount}
                                        updateTag={(tag) => {
                                            setState((prevState) => ({
                                                ...prevState,
                                                tagData: tag,
                                            }));
                                        }}
                                        handleTagClose={handleTagClose}
                                        refreshTag={props.refreshTag}
                                        allFields={props.configData.fields}
                                        allActions={props.allActions}
                                        processId={state.processId}
                                        statusId={state.statusId}
                                    />
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    ) : props.detailView === undefined &&
                      state.show_tag === false &&
                      state.user_permission?.processName !== 'Export' &&
                      state?.user_permission?.allActions?.hasOwnProperty(
                          'update_tag'
                      ) ? (
                        <span
                            className={
                                state.tagCount > 0
                                    ? 'details-tag contain-tag-value'
                                    : 'details-tag'
                            }
                            id='details-tag'
                            style={{ cursor: 'not-allowed' }}
                        >
                            <span
                                className={
                                    state.tagCount > 0
                                        ? 'fatag active'
                                        : 'fatag'
                                }
                            >
                                <i
                                    className={
                                        state.allActions.hasOwnProperty(
                                            'update_tag'
                                        ) &&
                                        state.allActions.update_tag.icon !==
                                            null
                                            ? state.allActions.update_tag.icon
                                            : 'fas fa-tag'
                                    }
                                    style={{
                                        color:
                                            state.allActions.hasOwnProperty(
                                                'update_tag'
                                            ) &&
                                            state.allActions.update_tag
                                                .color !== null
                                                ? state.allActions.update_tag
                                                      .color
                                                : '',
                                    }}
                                />
                            </span>
                            <span className='count'>
                                {state.tagData.length}{' '}
                            </span>
                        </span>
                    ) : null}
                </div>
            ) : null}
            {props.isEditDetails === false &&
            props.isPartialEditModeEnabled === false ? (
                <div>
                    <div
                        className={
                            props.isLocked
                                ? 'pdf-detail align-items-stretch justify-content-between locked-screen'
                                : 'pdf-detail align-items-stretch justify-content-between'
                        }
                    >
                        {process.env.REACT_APP_ENV === 'dev' ? (
                            <span className='document_file'>
                                {' '}
                                Document : #{props.selectedDocId}
                            </span>
                        ) : null}

                        {!props.isPartialEditModeEnabled && (
                            <div
                                className={
                                    props.isLocked
                                        ? 'right-function action-locked'
                                        : 'right-function d-flex justify-content-between align-items-stretch'
                                }
                            >
                                <div className='left-expand left-ex-btn'>
                                    <div
                                        className='ml-0 mr-2 left-pdf-button'
                                        onClick={expandAndOpenDetails}
                                        style={{ display: 'inline-block' }}
                                    >
                                        <span title='Expand'>
                                            <i className='fas fa-arrow-to-left' />
                                            Expand
                                        </span>
                                    </div>
                                    <div
                                        className='left-pdf-button'
                                        onClick={doCollapse}
                                        style={{ display: 'inline-block' }}
                                    >
                                        <span title='Collapse'>
                                            <i className='fas fa-arrow-to-right' />
                                            Collapse
                                        </span>
                                    </div>
                                </div>

                                <div className='right-expand'>
                                    {(props.showBranch ||
                                        state.show_branch ||
                                        props.showGroup ||
                                        state.show_inbox) &&
                                    !props.isPhyisicanSignatureDocument ? (
                                        <TransitionButton
                                            isLocked={props.isLocked}
                                            isOpenTransitionSection={
                                                state.open_transition_section
                                            }
                                            openTransitionSection={
                                                open_transition_section
                                            }
                                            allActions={state.allActions}
                                            entering={entering}
                                        />
                                    ) : null}

                                    <EditDetailsButton
                                        isLocked={props.isLocked}
                                        entering={entering}
                                        open_details_section={
                                            state.open_details_section
                                        }
                                        openEditDetailsFromDocumentDetail={
                                            openEditDetailsFromDocumentDetail
                                        }
                                        allActions={state.allActions}
                                    />

                                    <NotesButton
                                        isLocked={props.isLocked}
                                        entering={entering}
                                        isOpenNotesSection={
                                            state.open_notes_section
                                        }
                                        openNotesSection={open_notes_section}
                                    />

                                    {props.showPdf &&
                                    state.user_permission?.processName !==
                                        'Export' ? (
                                        <PDFEditButton
                                            isLocked={props.isLocked}
                                            showPdf={props.showPdf}
                                            userPermission={
                                                state.user_permission
                                            }
                                            editId={state.editId}
                                            updateState={props.updateState}
                                            history={props.history}
                                            rowDetails={props.rowDetails}
                                            allActions={state.allActions}
                                            entering={entering}
                                        />
                                    ) : null}

                                    <SettingsDropdown
                                        isLocked={props.isLocked}
                                        allActions={state.allActions}
                                        updateState={props.updateState}
                                        doCollapse={() => doCollapse()}
                                        handleHistroy={handleHistroy}
                                        printIt={() =>
                                            printIt([props.selectedDocId])
                                        }
                                        download={() => download()}
                                        showFaxModal={() => showFaxModal()}
                                        Update_fax_details={() =>
                                            Update_fax_details()
                                        }
                                        serviceType={state.serviceType}
                                        selectedDocId={props.selectedDocId}
                                        set_opendeletepopup={
                                            set_opendeletepopup
                                        }
                                        sendDraft={() => {
                                            sendDraft();
                                        }}
                                        count={props.count}
                                        user_permission={state?.user_permission}
                                        entering={entering}
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {state.open_transition_section &&
                    !props.isPartialEditModeEnabled ? (
                        <TransitionSection
                            allActions={state.allActions}
                            menu_name={props.menu_name}
                            processId={state.processId}
                            statusId={state.statusId}
                            statusArray={state.statusArray}
                            branches={props.branches}
                            groups={props.groups}
                            selectedDocId={props.selectedDocId}
                            userPermission={state?.user_permission}
                            showBranch={state.show_branch}
                            showGroup={state.show_group}
                            showInbox={state.show_inbox}
                            closeTransition={(param) => {
                                closeTransition.call(this);
                            }}
                            isLocked={props.isLocked}
                            menuGroup={props.menuGroup}
                            menuBranch={props.menuBranch}
                            menuInbox={props.menuInbox}
                            calingFrom={props.calingFrom}
                        />
                    ) : null}

                    <DetailsSection
                        openDetailsSection={state.open_details_section}
                        userPermission={state.user_permission}
                        isLocked={props.isLocked}
                        moreInformation={state.more_information}
                        openEditDetails={openEditDetailsFromDocumentDetail}
                        openMore={openMore}
                    />

                    <NotesSection
                        openNotesSection={state.open_notes_section}
                        noteCount={state.noteCount}
                        setNoteCount={() => {
                            let countNotes = state.noteCount + 1;

                            setState((prevState) => ({
                                ...prevState,
                                noteCount: countNotes,
                            }));
                        }}
                        noteTypes={state.noteTypes}
                        viewNotes={state.viewNotes}
                        showNotes={props.showNotes}
                        selectedDocId={props.selectedDocId}
                        handleReset={handleReset}
                    />

                    {state?.user_permission?.processName !== 'Export' &&
                    state.relatedDocRefresh === true ? (
                        <RelatedDocument
                            selectedDocId={props.selectedDocId}
                            isLocked={props.isLocked}
                            toggleSpinner={toggleSpinner}
                        />
                    ) : null}
                </div>
            ) : null}

            <UpdateFaxDetails
                calingFrom='smallview'
                openUpdateNotes={state.openUpdateNotes}
                selectedDocId={[state.selectedDocId]}
                updateState={(state) => {
                    setState((prevState) => ({
                        ...prevState,
                        ...state,
                    }));
                }}
                updateValue={state.updateValue}
                user_permission={state.user_permission}
            />

            <SendToFaxUploadModal
                calingFrom='smallview'
                showfaxNow={state.showfaxNow}
                processId={state.processId}
                statusId={state.statusId}
                selectedDocId={[state.selectedDocId]}
                updateState={(state) => {
                    setState((prevState) => ({
                        ...prevState,
                        ...state,
                    }));
                }}
                updateValue={state.updateValue}
                user_permission={state.user_permission}
            />

            <Modal
                show={state.openHistroy}
                onHide={() => {
                    handleHistroyClose();
                }}
                animation={false}
                size='lg'
                aria-labelledby='contained-modal-title-vcenter'
                centered
            >
                <Modal.Header
                    closeButton
                    className='d-block justify-content-start history_header'
                >
                    <Modal.Title className='d-flex d-flex wrap_history align-items-stretch justify-content-between'>
                        <div className='history_popup'>
                            <i className='fa fa-history' />
                            View History
                        </div>
                        <div className='d-flex align-items-center'>
                            <i
                                title='Close'
                                className='fa-light fa-xmark d-flex justify-content-end '
                                aria-hidden='true'
                                onClick={() => {
                                    handleHistroyClose();
                                }}
                            />
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='p-0 history-pop'>
                    <DocumentHistroy
                        openHistroy={state.openHistroy}
                        docId={state.docId}
                    />
                </Modal.Body>
            </Modal>
            <Notes
                openNote={state.openNote}
                docId={props.selectedDocId}
                handleReset={handleReset}
                openBigView={() => {
                    props.openBigView();
                }}
                updateState={() => {}}
            />
        </>
    );
};

const mapDispatchToProps = {
    showLoader: (canShow) => showLoader(canShow),
    getListaction: getListaction,
    inboxPage,
};
const mapStateToProps = (state, ownProps) => {
    const getInboxLocally = (name) => {
        switch (name) {
            case 'inbox': {
                let detailsData = localStorage.getItem('inbox_data');
                if (detailsData !== null) {
                    detailsData = JSON.parse(detailsData);
                } else {
                    detailsData = {};
                }
                return detailsData;
            }
            default:
                return {};
        }
    };
    return {
        inbox:
            stringEmptyOrUndefined(state.inbox.stateData) &&
            Object.keys(state.inbox.stateData).length > 0
                ? state.inbox
                : getInboxLocally('inbox'),
        processId: state.inbox.processId,
        statusId: state.inbox.statusId,
        configData:
            stringEmptyOrUndefined(state.configReducerPersist) &&
            stringEmptyOrUndefined(state.configReducerPersist.configData)
                ? state.configReducerPersist.configData
                : {},
        stateToken: state.inbox.stateToken,
        configuredRecordsets:
            state.configReducerPersist.configData.configuredRecordsets,
    };
};
export default React.memo(
    connect(mapStateToProps, mapDispatchToProps)(withRouter(DocumentDetail))
);
